import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const FavoriteStateContext = createContext(null);

export function FavoriteStateProvider({ children }) {
  const [favoriteMap, setFavoriteMap] = useState({});

  const hasFavorite = useCallback(
    (listingId) => Object.prototype.hasOwnProperty.call(favoriteMap, String(listingId)),
    [favoriteMap]
  );

  const getFavorite = useCallback(
    (listingId, fallback = false) => {
      const key = String(listingId);
      return Object.prototype.hasOwnProperty.call(favoriteMap, key)
        ? !!favoriteMap[key]
        : !!fallback;
    },
    [favoriteMap]
  );

  const setFavorite = useCallback((listingId, isFav) => {
    const key = String(listingId);
    const next = !!isFav;
    setFavoriteMap((prev) => {
      if (prev[key] === next) {
        return prev;
      }
      return { ...prev, [key]: next };
    });
  }, []);

  const value = useMemo(
    () => ({
      hasFavorite,
      getFavorite,
      setFavorite,
    }),
    [hasFavorite, getFavorite, setFavorite]
  );

  return (
    <FavoriteStateContext.Provider value={value}>
      {children}
    </FavoriteStateContext.Provider>
  );
}

export function useFavoriteState() {
  const context = useContext(FavoriteStateContext);
  if (!context) {
    throw new Error("useFavoriteState must be used within FavoriteStateProvider");
  }
  return context;
}
